export const CRYPTO_PAYMENTS_API_URL = 'https://dashboard.xtvultra.com:30013';
export const FIREBASE_API_URL = 'https://dashboard.xtvultra.com:30012';
export const PRICE_PER_TOKEN = process.env.PRICE_PER_TOKEN
  ? Number(process.env.PRICE_PER_TOKEN)
  : 3.99;
